import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster as HotToaster } from "react-hot-toast";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import { LanguageProvider } from "./contexts/LanguageContext";
import { OptimizedAnalyticsTracker } from "./components/cms/OptimizedAnalyticsTracker";
import AdminRoute from "./components/admin/AdminRoute";
import CookieBanner from "./components/CookieBanner";
import Index from "./pages/Index";
import ExpertisePage from "./pages/ExpertisePage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import OutilsPage from "./pages/OutilsPage";
import CompetencePage from "./pages/CompetencePage";
import SpeedInscriCaseStudy from "./pages/SpeedInscriCaseStudy";
import IdentiteVisuellePage from "./pages/IdentiteVisuellePage";
import StrategieMarquePage from "./pages/StrategieMarquePage";
import Communication360Page from "./pages/Communication360Page";
import CommunicationDigitalePage from "./pages/CommunicationDigitalePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminArticlesPage from "./pages/admin/AdminArticlesPage";
import AdminArticleEditorPage from "./pages/admin/AdminArticleEditorPage";
import AdminCMSPage from "./pages/admin/AdminCMSPage";
import DatabaseSetupPage from "./pages/admin/DatabaseSetupPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <HotToaster position="top-right" />
          <BrowserRouter>
            <OptimizedAnalyticsTracker />
            <CookieBanner />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/expertise" element={<ExpertisePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route path="/speed-inscri" element={<SpeedInscriCaseStudy />} />
              <Route path="/outils/:toolName" element={<OutilsPage />} />
              <Route path="/competences/:competenceSlug" element={<CompetencePage />} />
              <Route path="/identite-visuelle" element={<IdentiteVisuellePage />} />
              <Route path="/strategie-marque" element={<StrategieMarquePage />} />
              <Route path="/communication-360" element={<Communication360Page />} />
              <Route path="/communication-digitale" element={<CommunicationDigitalePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              } />
              <Route path="/admin/articles" element={
                <AdminRoute>
                  <AdminArticlesPage />
                </AdminRoute>
              } />
              <Route path="/admin/articles/new" element={
                <AdminRoute>
                  <AdminArticleEditorPage />
                </AdminRoute>
              } />
              <Route path="/admin/articles/edit/:id" element={
                <AdminRoute>
                  <AdminArticleEditorPage />
                </AdminRoute>
              } />
              <Route path="/admin/cms" element={
                <AdminRoute>
                  <AdminCMSPage />
                </AdminRoute>
              } />
              <Route path="/admin/database-setup" element={
                <AdminRoute>
                  <DatabaseSetupPage />
                </AdminRoute>
              } />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
